import { render, staticRenderFns } from "./SaleReturnReport.vue?vue&type=template&id=7126523f&"
import script from "./SaleReturnReport.vue?vue&type=script&lang=js&"
export * from "./SaleReturnReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports